import clsx from "clsx";

export function LiveInterviewMeetingRecordingBar({
  canManageRecording = false,
  recordingLive = false,
  recordingProcessing = false,
  recordingDurationLabel = "",
  recordingBusy = false,
  recordingError = "",
  onToggleRecording,
}) {
  const showReadonlyLive = recordingLive && !canManageRecording;
  const showHostControl = canManageRecording;
  if (!showReadonlyLive && !showHostControl) {
    return null;
  }

  const recordingTimer = String(recordingDurationLabel || "").trim();

  const chipClass = clsx(
    "li-meet-rec-chip",
    "is-icon-only",
    recordingProcessing && "is-processing",
    !recordingProcessing && recordingLive && "is-live",
    !recordingProcessing && !recordingLive && showHostControl && "is-idle",
  );

  const hostAriaLabel = recordingProcessing
    ? "Recording is processing"
    : recordingLive
      ? `Stop recording${recordingTimer ? `, ${recordingTimer} elapsed` : ""}`
      : "Start recording";

  const hoverLabel = recordingProcessing
    ? "Processing recording"
    : recordingLive
      ? "Recording"
      : "Start recording";

  const recordingHoverCard = (
    <div className="li-meet-rec-hover-card" role="tooltip">
      <span className="li-meet-rec-hover-label">{hoverLabel}</span>
      {recordingLive && recordingTimer ? (
        <span className="li-meet-rec-hover-time">{recordingTimer}</span>
      ) : null}
    </div>
  );

  return (
    <div className="li-meet-recording-bar" role="region" aria-label="Recording status">
      {showHostControl ? (
        <div className="li-meet-rec-control-wrap">
          <button
            type="button"
            className={clsx(chipClass, "is-action", "is-dot-only")}
            onClick={onToggleRecording}
            disabled={recordingBusy || recordingProcessing}
            aria-pressed={recordingLive ? "true" : "false"}
            aria-label={hostAriaLabel}
            title={hostAriaLabel}
          >
            <span
              className={clsx(
                "li-meet-rec-dot",
                !recordingLive && !recordingProcessing && "idle",
              )}
            />
          </button>
          {recordingHoverCard}
        </div>
      ) : (
        <div className="li-meet-rec-control-wrap">
          <div
            className={clsx(chipClass, "is-dot-only", "is-live")}
            aria-live="polite"
            aria-label={`Recording${recordingTimer ? `, ${recordingTimer}` : ""}`}
            title={`Recording${recordingTimer ? ` · ${recordingTimer}` : ""}`}
          >
            <span className="li-meet-rec-dot" />
          </div>
          {recordingHoverCard}
        </div>
      )}

      {recordingError ? (
        <span className="li-meet-recording-bar-error" aria-label={recordingError}>
          !
        </span>
      ) : null}
    </div>
  );
}
